import React from 'react';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import Button from 'material-ui/Button';
import {FormControlLabel} from 'material-ui/Form';

import tsl from '../tsl';
import axios from 'axios';
import { addAlert } from '../../actions/Alerts';
import {connect} from 'react-redux';

class PasswordResetRequest extends React.Component {

    state = {
        'email': '',
        requestSent: false
    };

    onChange = (e) => {
        let newState = this.state;
        newState[e.target.name] = e.target.value;
        
        this.setState(newState);
    };

    submit = (e) => {
        e.preventDefault();

        if (!this.state.email || this.state.email.length == 0) {
            return;
        }

        axios.post('/auth/password-reset', {
            'email': this.state.email
        })
        .then((res) => {
            this.props.history.push('/');

            this.props.addAlert(tsl('forgotpass.sent'), 'success', 10);
        })
    };

    goBack = () => {
        this.props.history.push('/app/flights');
    };

    render() {
        return (
            <div
                className="login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
                <div className="login-content">
                    <div className="login-header mb-4">
                        <a className="app-logo" href="#/" title="Jambo">
                            <img src="./assets/images/logo-white-red.png" alt="jambo" title="jambo"/>
                        </a>
                    </div>

                    <div className="login-form">
                        <h2>{tsl("forgotpass.title")}</h2>
                        <form onSubmit={this.submit}>
                            <fieldset>
                                <TextField
                                    name="email"
                                    value={this.state.email}
                                    onChange={this.onChange}
                                    label={tsl("login.email")}
                                    fullWidth
                                    margin="normal"
                                    className="mt-1"
                                    disabled={this.state.requestSent}
                                />

                                <br /><br />

                                <Button type="submit" raised color="primary"
                                    className="jr-btn text-white btn-primary"
                                        disabled={this.state.requestSent}
                                >
                                    {tsl("forgotpass.btn")}
                                </Button>
                                
                                <Button onClick={this.goBack}>
                                    {tsl("forgotpass.back")}
                                </Button>


                            </fieldset>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
};

export default connect(() => ({}), {addAlert})(PasswordResetRequest);



// WEBPACK FOOTER //
// ./app/used/PasswordResetRequest.js